export const cardStyle = {
  talentsButton: {
    marginLeft: 'auto',
    backgroundColor: 'transparent',
  },
  countinueButton: {
    backgroundColor: 'secondary.main',
  },
  card: {
    marginTop: '32px',
    backgroundColor: '#f3f4f6',
    position: 'relative',
  },
  box: {
    display: 'flex',
    flexDirection: 'row',
  },
  content: {
    padding: 0,
    pointerEvents: 'none',
  },
} as const;
